(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-404"]) return;
  try {
    
  (() => {
    const waitingRoot = document.querySelector('[data-pomlie-waiting]');
    const waitingRoute = document.documentElement.classList.contains('pomlie-waiting-route');

    if (!waitingRoot || !waitingRoute) return;

    const beforeOpen = waitingRoot.querySelector('[data-before-open]');
    const afterOpen = waitingRoot.querySelector('[data-after-open]');
    const hours = waitingRoot.querySelector('[data-hours]');
    const minutes = waitingRoot.querySelector('[data-minutes]');
    const seconds = waitingRoot.querySelector('[data-seconds]');
    let intervalId;

    document.title = waitingRoot.dataset.pageTitle;

    const pad = (value) => String(value).padStart(2, '0');

    const showOpenState = () => {
      beforeOpen.hidden = true;
      afterOpen.hidden = false;
      if (intervalId) window.clearInterval(intervalId);
    };

    const updateCountdown = () => {
      const remaining = new Date(waitingRoot.dataset.target).getTime() - Date.now();

      if (remaining <= 0) {
        showOpenState();
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      hours.textContent = pad(Math.floor(totalSeconds / 3600));
      minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      seconds.textContent = pad(totalSeconds % 60);
    };

    updateCountdown();
    intervalId = window.setInterval(updateCountdown, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pomlie-footer-main"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-pomlie-localization-select]').forEach((select) => {
  if (select.dataset.pomlieBound === 'true') return;
  select.dataset.pomlieBound = 'true';
  select.addEventListener('change', () => {
    if (select.form) select.form.submit();
  });
});

if (!document.querySelector('script[data-pomlie-tree-nation-script]') && !document.querySelector('script[src*="widgets.tree-nation.com/js/widgets"]')) {
  const treeNationScript = document.createElement('script');
  treeNationScript.src = 'https://widgets.tree-nation.com/js/widgets/v3/widgets.min.js';
  treeNationScript.defer = true;
  treeNationScript.dataset.pomlieTreeNationScript = 'true';
  document.head.appendChild(treeNationScript);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pomlie-footer-press"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pomlie-press')) {
  customElements.define('pomlie-press', class extends HTMLElement {
    connectedCallback() {
      this.rows = [...this.querySelectorAll('[data-pmp-row]')];
      this.embeds = [...this.querySelectorAll('[data-pmp-embed]')];
      this.rowWidths = new WeakMap();
      this.abort = new AbortController();
      this.queue = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.layout());
      };
      this.resizeObserver = new ResizeObserver(this.queue);
      this.resizeObserver.observe(this.querySelector('.pomlie-press__inner'));
      this.embeds.forEach(embed => {
        this.resizeObserver.observe(embed);
        this.resizeObserver.observe(embed.firstElementChild);
      });
      this.mutationObserver = new MutationObserver(this.queue);
      this.embeds.forEach(embed => this.mutationObserver.observe(embed, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['width', 'height']
      }));
      this.addEventListener('load', this.queue, {capture: true, signal: this.abort.signal});
      this.addEventListener('shopify:block:select', event => {
        const tile = event.target.closest('.pomlie-press__tile');
        const row = tile?.closest('[data-pmp-row]');
        if (row && getComputedStyle(row).overflowX === 'auto') this.center(row, tile, false);
      }, {signal: this.abort.signal});
      this.rows.forEach(row => {
        row.addEventListener('keydown', event => {
          if (event.target !== row || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          const step = event.key === 'ArrowRight' ? 1 : -1;
          const tiles = [...row.querySelectorAll('.pomlie-press__tile')];
          const center = row.getBoundingClientRect().left + row.clientWidth / 2;
          let index = 0;
          let distance = Infinity;
          tiles.forEach((tile, i) => {
            const box = tile.getBoundingClientRect();
            const delta = Math.abs(box.left + box.width / 2 - center);
            if (delta < distance) { distance = delta; index = i; }
          });
          event.preventDefault();
          this.center(row, tiles[Math.max(0, Math.min(tiles.length - 1, index + step))], true);
        }, {signal: this.abort.signal});
      });
      this.queue();
    }
    center(row, tile, animate) {
      const box = tile.getBoundingClientRect();
      const rowBox = row.getBoundingClientRect();
      const left = row.scrollLeft + box.left + box.width / 2 - rowBox.left - row.clientWidth / 2;
      row.scrollTo({
        left,
        behavior: animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'
      });
    }
    layout() {
      this.embeds.forEach(embed => {
        const canvas = embed.firstElementChild;
        const width = Math.max(canvas.offsetWidth, canvas.scrollWidth);
        const height = Math.max(canvas.offsetHeight, canvas.scrollHeight);
        if (!width || !height || !embed.clientWidth) return;
        const scale = Math.min(1, embed.clientWidth / width);
        const scaledHeight = Math.ceil(height * scale);
        if (embed.style.getPropertyValue('--pmp-embed-scale') !== String(scale)) {
          embed.style.setProperty('--pmp-embed-scale', String(scale));
        }
        if (embed.style.getPropertyValue('--pmp-embed-height') !== scaledHeight + 'px') {
          embed.style.setProperty('--pmp-embed-height', scaledHeight + 'px');
        }
      });
      this.rows.forEach(row => {
        const width = row.clientWidth;
        const scrollable = row.dataset.rowCount === '3' && getComputedStyle(row).overflowX === 'auto';
        if (scrollable) {
          row.tabIndex = 0;
          if (this.rowWidths.get(row) !== width) this.center(row, row.children[1], false);
        } else {
          row.removeAttribute('tabindex');
          row.scrollLeft = 0;
        }
        this.rowWidths.set(row, width);
      });
      this.dataset.pmpReady = 'true';
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pomlie-footer"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-pomlie-localization-select]').forEach((select) => {
  if (select.dataset.pomlieBound === 'true') return;
  select.dataset.pomlieBound = 'true';
  select.addEventListener('change', () => {
    if (select.form) select.form.submit();
  });
});

if (!document.querySelector('script[data-pomlie-tree-nation-script]') && !document.querySelector('script[src*="widgets.tree-nation.com/js/widgets"]')) {
  const treeNationScript = document.createElement('script');
  treeNationScript.src = 'https://widgets.tree-nation.com/js/widgets/v3/widgets.min.js';
  treeNationScript.defer = true;
  treeNationScript.dataset.pomlieTreeNationScript = 'true';
  document.head.appendChild(treeNationScript);
}

  } catch(e) { console.error(e); }
})();
})();
